<template>
  <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">الدارسين المفعلين</h1>
        <p class="mt-2 text-sm text-gray-700"></p>
      </div>
    </div>

    <div class="mt-4 mb-6">
      <div class="flex flex-col sm:flex-row gap-4">
        <div class="flex-1">
          <input
            v-model="searchQuery"
            @keyup.enter="handleSearch"
            type="text"
            placeholder="البحث باسم الطالب"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div class="flex gap-2">
          <button
            @click="handleSearch"
            class="button"
            :disabled="isLoading"
          >
            بحث
          </button>
          <button
            @click="clearSearch"
            class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 h-10"
          >
            مسح
          </button>
          <button
            class="button"
            type="button"
            @click="refreshStudents()"
            :disabled="isLoading"
          >
            {{ isLoading ? 'جاري التحميل...' : 'تحديث' }}
          </button>
        </div>
      </div>
    </div>


    <div class="mt-8 flex flex-col">
      <div class="sm:flex-auto">
        <h1 class="text-lg font-medium text-gray-900"> الحسابات المفعلة</h1>
        <p class="mt-2 text-xs text-gray-700">
          عرض {{ students.length }} من أصل {{ totalElements }} دارس
          <span v-if="totalPages > 0">(الصفحة {{ currentPage + 1 }} من {{ totalPages }})</span>
        </p>
      </div>

      <div v-if="!this.errorMessageStatus" class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-customHafadhColor">
              <thead class="bg-customHafadhColor text-center">
                <tr>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    الاسم
                  </th>
                  <!--
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    الايميل
                  </th>
                  --->
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    الجوال
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    المسار
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    مدة الاشتراك
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    التعليم
                  </th>
                  <!--
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    الهوية
                  </th>
                  --->
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    حالة الانسحاب
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    حالة الدارس
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    نسخة التطبيق
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    منصة التطبيق
                  </th>
                  <!--
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    تغير الرقم السري
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                    تغير بيانات الدارس
                  </th>
                  --->
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for=" (student, index) in students" :key="index">
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    {{ student.fullName }}
                  </td>
                  <!--
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {{ student.email }}
                  </td>
                  --->
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {{ student.phone }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {{ student.massaratValue }}
                  </td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    {{ student.engagementPreference }}
                  </td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    {{ student.qualificationValue }}
                  </td>
                  <!--
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    {{ student.nationalId }}
                  </td>
                  --->
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    <Switch @click="onClickStatusOfCanWithdraw(index, !student.canWithdraw)"
                      v-model="student.canWithdraw" :class="[
          student.canWithdraw ? 'bg-blue-600' : 'bg-gray-200',
          'mr-2 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
        ]">
                      <span class="sr-only"></span>
                      <span :class="[
          student.canWithdraw ? '-translate-x-5' : 'translate-x-0',
          'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
        ]">
                        <span :class="[
          student.canWithdraw
            ? 'opacity-0 ease-out duration-100'
            : 'opacity-100 ease-in duration-200',
          'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
        ]" aria-hidden="true">
                          <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                            <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span>
                        <span :class="[
          student.canWithdraw
            ? 'opacity-100 ease-in duration-200'
            : 'opacity-0 ease-out duration-100',
          'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
        ]" aria-hidden="true">
                          <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                            <path
                              d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                          </svg>
                        </span>
                      </span>
                    </Switch>
                  </td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    <Switch @click="onClickStatusOfStudent(index, !student.isEnabled)" v-model="student.isEnabled"
                      :class="[
          student.isEnabled ? 'bg-blue-600' : 'bg-gray-200',
          'mr-2 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
        ]">
                      <span class="sr-only"></span>
                      <span :class="[
          student.isEnabled ? '-translate-x-5' : 'translate-x-0',
          'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
        ]">
                        <span :class="[
          student.isEnabled
            ? 'opacity-0 ease-out duration-100'
            : 'opacity-100 ease-in duration-200',
          'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
        ]" aria-hidden="true">
                          <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                            <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span>
                        <span :class="[
          student.isEnabled
            ? 'opacity-100 ease-in duration-200'
            : 'opacity-0 ease-out duration-100',
          'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
        ]" aria-hidden="true">
                          <svg class="h-3 w-3 text-blue-600" fill="currentColor" viewBox="0 0 12 12">
                            <path
                              d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                          </svg>
                        </span>
                      </span>
                    </Switch>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <div v-if="student.appVersion" class="flex flex-col">
                      <span class="font-medium">{{ student.appVersion }}</span>
                      <span v-if="student.appBuildNumber" class="text-xs text-gray-400">
                        (Build: {{ student.appBuildNumber }})
                      </span>
                      <span v-if="student.appVersionUpdatedAt" class="text-xs text-gray-400">
                        {{ formatDate(student.appVersionUpdatedAt) }}
                      </span>
                    </div>
                    <span v-else class="text-gray-400 italic">غير متاح</span>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="student.appPlatform" class="font-medium">
                      {{ student.appPlatform === 'android' ? 'Android' : student.appPlatform === 'ios' ? 'iOS' : student.appPlatform }}
                    </span>
                    <span v-else class="text-gray-400 italic">غير متاح</span>
                  </td>
                  <!--
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    <button class="enabled-button" @click="openPopupPassword(index)">تغير</button>
                  </td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                    <button class="enabled-button" @click="openPopupChangeDetiles(index)">تغير</button>
                  </td>
                  --->
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Pagination -->
        <div v-if="totalPages > 1" class="mt-6 flex items-center justify-between">
          <div class="flex-1 flex justify-between sm:hidden">
            <button
              @click="previousPage"
              :disabled="currentPage === 0 || isLoading"
              class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              السابق
            </button>
            <button
              @click="nextPage"
              :disabled="!hasNext || isLoading"
              class="mr-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              التالي
            </button>
          </div>
          <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
            <div>
              <p class="text-sm text-gray-700">
                عرض <span class="font-medium">{{ startIndex + 1 }}</span> إلى <span class="font-medium">{{ endIndex }}</span>
                من أصل <span class="font-medium">{{ totalElements }}</span> نتيجة
              </p>
            </div>
            <div>
              <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                <button
                  @click="previousPage"
                  :disabled="currentPage === 0 || isLoading"
                  class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span class="sr-only">السابق</span>
                  <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                  </svg>
                </button>
                <button
                  v-for="page in visiblePages"
                  :key="page"
                  @click="goToPage(page)"
                  :class="[
                    page === currentPage + 1
                      ? 'z-10 bg-customHafadhColor border-customHafadhColor text-white'
                      : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                    'relative inline-flex items-center px-4 py-2 border text-sm font-medium'
                  ]"
                >
                  {{ page }}
                </button>
                <button
                  @click="nextPage"
                  :disabled="!hasNext || isLoading"
                  class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span class="sr-only">التالي</span>
                  <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                  </svg>
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div v-if="this.errorMessageStatus">
        <h1 style="color: red;"> {{ this.errorMessage }}</h1>
      </div>
    </div>

    <!-- Password Popup -->
    <div v-if="showPopupPassword" class="popup" dir="rtl">
      <div class="popup-content">
        <h3 class="text-lg leading-6 font-medium text-gray-900">تغيير الرقم السري</h3>
        <div class="col-span-6 sm:col-span-3 mt-10">
          <label for="password" class="block text-sm font-medium text-gray-700">
            كلمة المرور
          </label>
          <input name="password" id="password" v-model="password" placeholder="الرقم السري"
            class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            required oninvalid="this.setCustomValidity('الرجاء ادخال الرقم السري')" oninput="setCustomValidity('')"
            :type="showPassword ? 'text' : 'password'" @input="validatePassword" />
          <span v-if="passwordError" class="text-center text-red-500 text-xs">{{ passwordError }}</span>
        </div>
        <div class="col-span-6 sm:col-span-3 mt-5">
          <label for="confirmPassword" class="block text-sm font-medium text-gray-700">
            اعادة ادخال كلمة المرور
          </label>
          <input name="confirmPassword" id="confirmPassword" v-model="confirmPassword" placeholder="الرقم السري"
            class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            required oninvalid="this.setCustomValidity('الرجاء ادخال الرقم السري')" oninput="setCustomValidity('')"
            :type="showPassword ? 'text' : 'password'" @input="validatePassword" />
          <span v-if="confirmPasswordError" class="text-center text-red-500 text-xs">{{ confirmPasswordError
            }}</span>
        </div>
        <div class="block text-sm font-medium text-gray-700 mt-5 mr-2">
          <input type="checkbox" v-model="showPassword" />
          عرض كلمة المرور
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
          <button
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
            @click="submitPassword()" type="submit" :disabled="passwordSuccess"
            :class="{ 'cursor-not-allowed': passwordSuccess }">تم</button>
          <button
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
            @click="closePopup" type="button">الغاء</button>
        </div>
      </div>
    </div>

    <!-- Change Detiles Popup -->
    <div v-if="showPopupChangeDetiles" class="popup" dir="rtl">
      <div class="popup-content">
        <h3 class="text-lg leading-6 font-medium text-gray-900">تغيير بيانات الدارس</h3>
        <div class="col-span-6 sm:col-span-3 mt-10">
          <label for="password" class="block text-sm font-medium text-gray-700">
            الايميل
          </label>
          <input name="email" id="email" v-model="email" placeholder="الايميل"
            class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            required oninvalid="this.setCustomValidity('الرجاء ادخال الايميل')" oninput="setCustomValidity('')"
            @input="validateEmail" />
          <span class="text-center text-red-500 text-xs" v-if="emailError">{{ emailError
            }}</span>
        </div>
        <div class="col-span-6 sm:col-span-3 mt-5">
          <label for="confirmPassword" class="block text-sm font-medium text-gray-700">
            رقم الهاتف
          </label>
          <div class="mt-1 flex">
            <span
              class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">+966</span>
            <input type="text" name="phone" id="phone" v-model="phone" placeholder="رقم الهاتف"
              class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              required oninvalid="this.setCustomValidity('الرجاء رقم رقم الهاتف')" oninput="setCustomValidity('')"
              maxlength="9" minlength="9" />
          </div>
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
          <button
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
            @click="submitDetiles()" type="submit">تم</button>
          <button
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
            @click="closePopup" type="button">الغاء</button>
        </div>
      </div>
    </div>
  </div>







</template>
<script>
import url from '@/url';
import axios from 'axios';
import { defineComponent } from 'vue';

class StudentDto {
  constructor(data) {
    this.id = data.id || null;
    this.email = data.email || null;
    this.fullName = data.fullName || null;
    this.engagementPreference = data.engagementPreference || null;
    this.qualificationValue = data.qualificationValue || null;
            // this.nationalId = data.nationalId || null; // Removed as it's not essential for app functionality
    this.canWithdraw = data.canWithdraw || false;
    this.isEnabled = data.isEnabled || false;
    this.phone = data.phone || false;
    this.massaratValue = data.massaratValue || null;
    this.appVersion = data.appVersion || null;
    this.appPlatform = data.appPlatform || null;
    this.appBuildNumber = data.appBuildNumber || null;
    this.appVersionUpdatedAt = data.appVersionUpdatedAt || null;
  }
}
export default defineComponent({
  data() {
    return {
      students: [],
      showPopupPassword: false,
      showPopupChangeDetiles: false,
      password: '',
      confirmPassword: '',
      userIndex: '',
      showPassword: false,
      passwordError: '',
      passwordSuccess: true,
      confirmPasswordError: '',
      errorMessage: "لا يوجد دارسين مفعلين",
      errorMessageStatus: false,
      email: '',
      phone: '',
      emailError: "",
      isLoading: false,
      pageSize: 20,
      currentPage: 0,
      totalElements: 0,
      totalPages: 0,
      startIndex: 0,
      endIndex: 0,
      visiblePages: [],
      hasNext: false,
      searchQuery: '',
    }
  },
  mounted() {
    this.getAllNewStudents();
  },
  methods: {
    async getAllNewStudents() {
      this.isLoading = true;
      this.students = [];
      this.errorMessageStatus = false;

      try {
        const params = {
          isNew: '0',
          isDeactivated: '0',
          page: this.currentPage,
          size: this.pageSize,
        };
        if (this.searchQuery && this.searchQuery.trim() !== '') {
          params.search = this.searchQuery.trim();
        }
        const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.get_all_students,
          {
            params,
            headers: {
              'X-Authorization': localStorage.getItem('token'),
            },
          },
        );

        const responseData = response.data.result.data;
        const studentsArray = responseData.content || responseData;

        if (!studentsArray || studentsArray.length === 0) {
          this.errorMessageStatus = true;
          this.errorMessage = "لا يوجد دارسين مفعلين";
          this.totalElements = 0;
          this.totalPages = 0;
          this.visiblePages = [];
          return;
        }

        this.students = studentsArray.map(studentData => new StudentDto(studentData));
        this.totalElements = responseData.totalElements ?? studentsArray.length;
        this.totalPages = responseData.totalPages ?? Math.ceil(this.totalElements / this.pageSize);
        this.hasNext = responseData.hasNext ?? this.currentPage < this.totalPages - 1;
        this.startIndex = this.currentPage * this.pageSize;
        this.endIndex = Math.min(this.startIndex + this.students.length, this.totalElements);
        this.updateVisiblePages();
        this.errorMessageStatus = false;
      } catch (error) {
        this.errorMessageStatus = true;
        this.errorMessage = "خطأ في جلب بيانات الدارسين";
        console.error('Error fetching students:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async onClickStatusOfCanWithdraw(index, statusOfCanWithdraw) {
      let studentId = this.students[index].id;
      let status = statusOfCanWithdraw ? "1" : "0";

      try {
        const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.withdrawalStatus + studentId + "?enable=" + status,
          {},
          {
            headers: {
              'X-Authorization': localStorage.getItem('token'),
            },
          },
        );
        if (response.status == 200) {
          this.students[index].canWithdraw = statusOfCanWithdraw
        }
      } catch (error) {
        console.error(error);
      }

    },
    async onClickStatusOfStudent(index, isEnabled) {
      let studentId = this.students[index].id;
      let status = isEnabled ? "1" : "0";

      try {
        const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.userStatus + studentId + "?enable=" + status,
          {},
          {
            headers: {
              'X-Authorization': localStorage.getItem('token'),
            },
          },
        );
        if (response.status == 200) {
          this.students[index].isEnabled = isEnabled
        }
      } catch (error) {
        console.error(error);
      }

    },
    openPopupPassword(index) {
      this.showPopupPassword = true;
      this.passwordSuccess = true;
      this.password = '';
      this.confirmPassword = '';
      this.userIndex = index;
    },
    openPopupChangeDetiles(index) {
      this.showPopupChangeDetiles = true;
      this.userIndex = index;
      this.phone = this.students[this.userIndex].phone;
      this.email = this.students[this.userIndex].email;
    },
    closePopup() {
      this.showPopupPassword = false;
      this.showPopupChangeDetiles = false;
      this.password = '';
      this.confirmPassword = '';
    },
    async submitPassword() {
      if (this.password !== this.confirmPassword) {
        //todo here need to check 
      } else {
        let userId = this.students[this.userIndex].id;
        try {
          const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.changePassword + userId + "?newPassword=" + btoa(this.password),
            {
            },
            {
              headers: {
                'X-Authorization': localStorage.getItem('token'),
              },
            },
          );
          console.log(response);
          if (response.status == 200) {
            alert("تم تغيير الرقم السري بنجاح!");
            this.closePopup();
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    async submitDetiles() {
      let userId = this.students[this.userIndex].id;
      try {
        const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.change_email_phone,
          {
            "email": this.email,
            "phone": this.phone,
            "userId": userId,
          },
          {
            headers: {
              'X-Authorization': localStorage.getItem('token'),
            },
          },
        );
        console.log(response);
        if (response.status == 200) {
          alert("تم تغيير البيانات بنجاح!");
          this.closePopup();
          this.getAllNewStudents();
        }
      } catch (error) {
        console.error(error);
      }
    },
    validatePassword() {
      // Reset error messages
      this.passwordError = '';
      this.confirmPasswordError = '';

      const specialCharRegex = /[@#!]/i;
      const uppercaseRegex = /[A-Z]/;
      const lowercaseRegex = /[a-z]/;
      const numberRegex = /[0-9]/;

      if (specialCharRegex.test(this.password) && uppercaseRegex.test(this.password) &&
        lowercaseRegex.test(this.password) && numberRegex.test(this.password)) {
        if (this.password !== this.confirmPassword && this.confirmPassword) {
          this.confirmPasswordError = 'كلمة المرور غير متطابقة';
          this.passwordSuccess = true;
        }
        else {
          this.passwordSuccess = false;
        }
      } else if (this.password) {
        this.passwordError =
          'الرقم السري يجب أن يكون بين 8 و 15 حرفا, الرقم السري يجب أن يكون مكون من علامة مميزة مثل "@#!" , يجب أن تحتوي كلمة المرور على أحرف كبيرة و صغيرة';
        this.passwordSuccess = true;
      }
    },
    validateEmail() {
      // Regular expression for basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email) && this.email.length != 0) {
        this.emailError = "الرجاء ادخال الايميل بشكل صحيح";
      } else {
        this.emailError = "";
      }
    },
    refreshStudents() {
      this.currentPage = 0;
      this.getAllNewStudents();
    },
    handleSearch() {
      this.currentPage = 0;
      this.getAllNewStudents();
    },
    clearSearch() {
      this.searchQuery = '';
      this.currentPage = 0;
      this.getAllNewStudents();
    },
    previousPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
        this.getAllNewStudents();
      }
    },
    nextPage() {
      if (this.hasNext) {
        this.currentPage++;
        this.getAllNewStudents();
      }
    },
    goToPage(page) {
      this.currentPage = page - 1;
      this.getAllNewStudents();
    },
    updateVisiblePages() {
      const maxVisiblePages = 5;
      const totalPages = this.totalPages;
      const currentPage = this.currentPage + 1;

      let start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
      let end = Math.min(totalPages, start + maxVisiblePages - 1);

      if (end - start + 1 < maxVisiblePages) {
        start = Math.max(1, end - maxVisiblePages + 1);
      }

      this.visiblePages = [];
      for (let i = start; i <= end; i++) {
        this.visiblePages.push(i);
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('ar-SA', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return dateString;
      }
    },
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Tailwind utility classes for enabled and disabled button states */
.enabled-button {
  @apply px-4 py-2 bg-primary text-white rounded hover:bg-hafadh-olive-dark w-20 h-10;
}

.disabled-button {
  @apply px-4 py-2 bg-gray-300 text-gray-500 rounded cursor-not-allowed w-20 h-10;
}

.button-background {
  @apply bg-primary;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  @apply bg-white p-5 rounded-lg;
  width: 580px;
  height: 380px;
  text-align: center;
}

.button {
  @apply px-4 py-2 bg-primary text-white rounded hover:bg-hafadh-olive-dark w-20 h-10;
}
</style>